
<div class="flow-search-result-container" :state="state" :type="type" :fullWidth="fullWidth">
	<div class="flow-search-result-wrapper">
		<div class="flow-search-result">
			<slot />
		</div>
		<div class="flow-search-result-actions">
			<slot name="actions" />
		</div>
	</div>
	<div v-if="$slots['expand-content']" class="flow-search-expandresult" :expanded="expanded">
		<slot name="expand-content" />
	</div>
</div>
